import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  /* exporting from campaign */
  function getCurrencyByCountry(countryId: string): string {
    switch (countryId) {
      case "ID":
        return "IDR";
      case "MY":
        return "MYR";
      case "TH":
        return "THB";
      default:
        return "";
    }
  }

  return {
    getCurrencyByCountry,
  };
}
